import React from 'react';
import ChartSingleValue from '@/components/ChartSingleValue';
import { useSelector } from 'react-redux';
import { getChartingOptions } from '@/store-selectors';
import ChartHolder from '@/components/ChartHolder';
import { useConfiguredDataTable } from '@/features/queryMetricsDimensionsConfig/metricConfigSlice';
import { useAppSelector } from '@/store/hooks';
import { selectIsLoadingRows } from '@/features/query-builder/queryBuilderSlice';
import { LoadingTimer } from './LoadingTimer';

export const SingleValueDataPresentation = () => {
  const dataTable = useConfiguredDataTable();
  const isLoading = useAppSelector(selectIsLoadingRows);
  const chartingOptions = useSelector(getChartingOptions);

  if (isLoading || !dataTable) return <LoadingTimer />;

  const getChartOption = (configItem: string[]) => {
    const section = configItem[0];
    const item = configItem[1];
    if (!chartingOptions) {
      return null;
    }
    // @ts-expect-error: TODO: fix.
    const sectionObj = chartingOptions[section] || {};
    const result = sectionObj[item];
    // undefined is used to control default value
    if (result === undefined && configItem.length > 2) {
      return configItem[2];
    }
    return result;
  };

  return (
    <ChartSingleValue
      dataTable={dataTable}
      getChartOption={getChartOption}
      isSingleCell={ChartHolder.isSingleCell(dataTable)}
      isSingleValueWithTrend={ChartHolder.canBeSingleValueWithTrend(
        dataTable.headings(),
      )}
    />
  );
};
